import React from 'react';

/**
 * Fängt Render-Fehler einer Teilansicht ab, damit ein kaputter Stream/Markdown
 * nicht die ganze PWA in einen weißen Screen reißt. Mit key={tab} in App.js
 * remountet die Boundary beim Tab-Wechsel und setzt sich so zurück.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('UI-Render-Fehler:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary">
          <div className="error-boundary-icon">⚠</div>
          <p className="error-boundary-title">Diese Ansicht konnte nicht geladen werden</p>
          <p className="error-boundary-sub">Ein unerwarteter Fehler ist aufgetreten. Der Rest der App läuft weiter.</p>
          <button className="btn-primary" onClick={() => this.setState({ error: null })}>Erneut versuchen</button>
        </div>
      );
    }
    return this.props.children;
  }
}
